import { useMutation, useQueryClient } from '@tanstack/react-query'

import api from '../../api'
import type { GcpProjectDetailsUpdate } from '../../api/gcpProjects/updateDetails'

const useUpdateGcpProjectDetails = (gcpProjectID: string) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (details: Record<string, unknown>) =>
			api.gcpProjects.updateDetails({
				gcpProjectID,
				action: 'UPDATE_DETAILS',
				details
			} as GcpProjectDetailsUpdate),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['gcpProjects'] })
			queryClient.invalidateQueries({
				queryKey: ['gcpProjects', gcpProjectID]
			})
		}
	})
}

export default useUpdateGcpProjectDetails
